import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[authorityLabsAutofocus]'
})
export class AutofocusDirective implements AfterContentInit {
  constructor(private el: ElementRef) {}

  ngAfterContentInit() {
    setTimeout(() => this.el.nativeElement.focus(), 500);
  }
}
